import { Link } from 'react-router-dom';
import Kay from "@/assets/kay_elu.jpeg";
import Yak from "@/assets/yak_kay.jpeg";
import Martins from "@/assets/martins.jpeg";
import Simb from "@/assets/sim_akin.jpeg";

const speakers = [
  {
    name: 'Dr. Kayode Elusoji',
    role: 'AI Research Engineer & Executive Director, GNA',
    bio: 'Visionary AI Research Engineer and Executive Director of GNA, driving AI adoption across African businesses and positioning the continent for the future.',
    sessions: [],
    image: Kay,
  },
  {
    name: 'Dr. Yakubu Kayode Saheed',
    role: 'Regional Director — Africa & Middle East, i3Cert Inc.',
    bio: 'Specialist in AI-driven marketing systems and customer acquisition strategies, helping businesses unlock exponential growth.',
    sessions: [],
    image: Yak,
  },
  {
    name: 'GN. Olalekan Martins',
    role: 'CEO - Living Gold Consulting',
    bio: 'AI and CyberSecurity expert with over 35 years experience in information technology consulting services',
    sessions: [],
    image: Martins,
  },
  {
    name: 'Arch. Simbo Akinola-Odusola',
    role: 'Business Consultant & GNA Pacesetter Award Committee Member',
    bio: 'A seasoned business consultant and distinguished GNA Pacesetter Award Committee Member, opening the summit with a compelling vision for AI-powered business growth.',
    sessions: [],
    image: Simb,
  },
];

const SpeakersSection = () => {
  return (
    <section id="speakers" className="py-20 md:py-28 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-green-700/20 border border-green-500/30 text-green-300 text-xs font-semibold uppercase tracking-widest mb-4">
            Featured Speakers
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Meet Your AI Guides
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            Industry leaders who have transformed businesses with AI — ready to share their proven strategies with you.
          </p>
        </div>

        {/* Speaker Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {speakers.map((speaker, idx) => (
            <div
              key={speaker.name}
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:-translate-y-2 transition-all duration-300 cursor-default"
              style={{ marginTop: idx % 2 === 1 ? '24px' : '0' }}
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={speaker.image}
                  alt={speaker.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-transparent to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-white font-bold text-base mb-1">{speaker.name}</h3>
                <p className="text-amber-400 text-xs font-semibold mb-3 leading-snug">{speaker.role}</p>
                <p className="text-gray-400 text-xs leading-relaxed mb-4">{speaker.bio}</p>

                {/* Sessions */}
                <div className="space-y-1.5">
                  {speaker.sessions.map((s) => (
                    <div key={s} className="flex items-start gap-2">
                      <i className="ri-mic-line text-green-400 text-xs mt-0.5 shrink-0"></i>
                      <span className="text-gray-300 text-xs leading-snug">{s}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Speakers Link */}
        <div className="mt-12 text-center flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/speakers"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 border border-white/20 text-white font-semibold text-sm hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-star-line"></i>
            View Full Speaker Profiles
          </Link>
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white/5 border border-white/10">
            <i className="ri-question-answer-line text-amber-400"></i>
            <span className="text-gray-300 text-sm">All 4 speakers join the live <strong className="text-white">AI Business Clinic Q&amp;A</strong></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakersSection;
